<template>
  <div>
    <b-form-group
      class="mb-3"
      :label="label"
      :invalid-feedback="inputInvalid"
      :state="state"
      :class="col"
    >
      <div v-if="tipoData == 'calendario'">
        <date-picker v-model="calendario" type="date" :placeholder="inputText" :disabled-date="disabledData" :value-type="formato" :first-day-of-week="1" @input="enviandoCalendario" :format="formato"></date-picker>
      </div>

      <div v-if="tipoData == 'ano'">
        <date-picker v-model="ano" type="year" value-type="YYYY" :disabled-date="disabledData" @input="enviandoAno" :placeholder="inputText"></date-picker>
      </div>

      <div v-if="tipoData == 'mes'">
        <date-picker v-model="mes" type="month" @input="enviandoMes" :format="formato" :value-type="formato" :disabled-date="disabledData" :placeholder="inputText"></date-picker>
      </div>

      <div v-if="tipoData == 'intervalo'">
        <date-picker v-model="intervalo" range append-to-body @input="enviandoIntervalo" :format="formato" :disabled-date="disabledData" :value-type="formato" :placeholder="inputText"></date-picker>
      </div>

    </b-form-group>

  </div>
</template>
<script>
  import DatePicker from "vue2-datepicker";

  export default {
    props: {
      label: String, // para dar nome ao campo
      inputText: String, // placeholder
      inputInvalid: String, // mensagem para campo invalido
      col: String, // definindo o tamanho do input na tela de acordo com cada caso
      disabled: Boolean, // para habilitar ou desabilitar o campo
      disabledData: Function, // para habilitar ou desabilitar datas futuras ao dia atual
      tipoData: String, // para saber o tipo de input a ser exibido
      formato: String, // para saber o tipo de formato e valor dos campos
      filtro: String, // envia dados do componente pai para o filho
      filtroIntervalo: Array, // envia o array de intervalo do componente pai para o filho
      validado: Boolean // controla a cor dos campos
    },

    components: {
      DatePicker,
    },

    created(){
      this.atribuiValoresFiltro()
    },

    computed: {
      state() {
        this.atribuiValoresFiltro()
        if((this.validado || this.validado === false) && (this.estado === null || this.estado === false)){
          return this.validado
        }
        return this.estado
      },
    },


    data() {
      return {
        calendario: '',
        ano: '',
        mes: '',
        intervalo: '',
        cpfSemMascara: '',
        dataDisabled: null,
        validando: null,
        estado: null
      }
    },

    methods: {
      enviandoCalendario(){
        if(this.calendario === '' || this.calendario === null){
          this.estado = null
        } else {
          this.estado = true
        }
        this.$emit("emitindoCalendario", this.calendario);
      },
      enviandoAno(){
        if(this.ano === '' || this.ano === null){
          this.estado = null
        } else {
          this.estado = true
        }
        this.$emit("emitindoAno", this.ano);
      },
      enviandoMes(){
        if(this.mes === '' || this.mes === null){
          this.estado = null
        } else {
          this.estado = true
        }
        this.$emit("emitindoMes", this.mes);
      },
      enviandoIntervalo(){
        if((this.intervalo[0] === '' || this.intervalo[0] === null) && (this.intervalo[1] === '' || this.intervalo[1] === null)){
          this.estado = null
        } else {
          this.estado = true
        }
        this.$emit("emitindoIntervalo", this.intervalo[0], this.intervalo[1]);
      },
      atribuiValoresFiltro(){
        if(this.filtro){
          if(this.tipoData == 'calendario'){
            this.calendario = this.filtro
          }
          if(this.tipoData == 'ano'){
            this.ano = this.filtro
          }
          if(this.tipoData == 'mes'){
            this.mes = this.filtro
          }
        }
        if(this.filtroIntervalo){
          this.intervalo = this.filtroIntervalo
        }
        if(this.disabledData){
          this.dataDisabled = { to: (date) => date >= new Date()}
        }
        return
      }
    }
  }
</script>

<style>

.is-valid .mx-input {
  border-color: #34c38f !important;
}

.is-invalid .mx-input {
  border-color: #f46a6a !important;
}

</style>
